import React from 'react';
import './RefundPolicy.css';

const RefundPolicy = ({ onBack }) => {
    return (
        <div className="refund-container">
            <div className="refund-header">
                <button className="back-button" onClick={onBack}>
                    ← Back
                </button>
            </div>
            <div className="refund-content">
                <div className="refund-text">
                    <h3>Refund & Return Policy</h3>
                    <p>This Return and Refund Policy governs all digital subscriptions purchased through the AI companion application ("App") operated by Walm Innovations Private Limited ("Walm", "we", "our", or "us"). It complies with the Consumer Protection (E-Commerce) Rules, 2020, the Information Technology Act, 2000, and RBI Guidelines on digital transactions. By purchasing a subscription or using premium services, you agree to this policy in full.</p>

                    <p>Our App provides digital, instantly accessible AI-based companion services, classified as digital goods under Indian law. Since access is granted immediately upon successful payment, refunds are generally not applicable except under specific, verifiable circumstances defined below.</p>

                    <h3>Subscription Terms</h3>
                    <p>Subscriptions are billed in advance on a recurring basis (daily, weekly, monthly, quarterly, or annually). Users can cancel auto-renewal anytime through in-app settings. Cancellation stops future renewals but does not automatically generate a refund for the ongoing billing period.</p>

                    <h3>Eligibility for Refunds</h3>
                    <p>Refunds will be considered only in the following cases:</p>
                    <ul>
                        <li><strong>Duplicate payment</strong> for the same subscription period.</li>
                        <li><strong>Successful payment but no access</strong> to premium features within 24 hours.</li>
                        <li><strong>Incorrect billing</strong> due to a technical or gateway error.</li>
                        <li><strong>Cancellation before premium access</strong> was granted but still charged.</li>
                    </ul>
                    <p>Refunds will not be issued for: change of mind, dissatisfaction with AI responses, limited usage, or device issues not caused by Walm.</p>

                    <h3>Refund Request Window</h3>
                    <p>All eligible refund requests must be submitted within 7 calendar days of the transaction date to arpit@chaimate.ai. Requests after 7 days will not be considered.</p>

                    <h3>Refund Process and Timelines</h3>
                    <p>Once verified and approved, refunds are processed to the original payment method within 5–10 working days, as per RBI timelines. Walm is not liable for delays caused by banks, payment gateways, intermediaries.</p>

                    <h3>Cancellation Procedure</h3>
                    <p>Go to App Settings → Subscription → Manage Plan and disable auto-renewal. You will continue to have access to premium features until your current billing cycle ends. No partial or prorated refunds are issued for mid-cycle cancellations.</p>

                    <h3>Dispute Resolution</h3>
                    <p>Any dispute related to billing or refunds will be governed by Indian law, with jurisdiction in Ahmedabad, Gujrat, India.</p>

                    <h3>Policy Updates</h3>
                    <p>Walm Innovations Private Limited reserves the right to modify this policy at any time without prior notice. The latest version will always be available within the app or on our website.</p>

                    <h3>Contact Information</h3>
                    <p><strong>Walm Innovations Private Limited</strong></p>
                    <p><strong>Email:</strong> arpit@chaimate.ai</p>
                    <p><strong>Phone Number:</strong> 8209561672</p>
                </div>
            </div>
        </div>
    );
};

export default RefundPolicy;

